<template>
  <div class="wrapper mt-10" style="margin-bottom: 75px !important">
    <div class="wrapper-login-box">
      <h2>Log in</h2>
      <ValidationObserver ref="observer">
        <div class="mt-4">
          <div class="mb-2">
            <div class="mb-2">
              <ValidationProvider name="ชื่อ" :rules="'required'" v-slot="{ errors }">
                <h4 class="my-1">Name</h4>
                <!-- <PasswordInput v-model="input.name" :errors="errors" /> -->
                <v-text-field
                  v-model="input.name"
                  placeholder="Name"
                  dense
                  type="text"
                  outlined
                  clearable
                  required
                  @click:clear="$emit('input', null)"
                  :hide-details="errors.length ? false : true"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </div>
            <ValidationProvider
              name="เบอร์โทรศัพท์"
              :rules="'required|thai_phonenumber'"
              v-slot="{ errors }"
            >
              <h4 class="my-1">Phone No.</h4>
              <ThaiPhoneNumber v-model="input.phone_number" :errors="errors"></ThaiPhoneNumber>
            </ValidationProvider>
          </div>
          <!-- <div class="mb-2">
            <ValidationProvider name="รหัสผ่าน" :rules="'required'" v-slot="{ errors }">
              <h4 class="my-1">Password</h4>
              <PasswordInput v-model="input.password" :errors="errors" />
            </ValidationProvider>
          </div> -->
          <div class="d-flex flex-column mt-5">
            <v-layout row justify-center align-center class="my-3">
              <vue-recaptcha
                ref="recaptcha"
                :key="`recaptcha_${timestamp}`"
                @verify="loginByUsername"
                :loadRecaptchaScript="true"
                :sitekey="setting.googleRecaptchaSiteKey"
              >
              </vue-recaptcha>
            </v-layout>
            <v-btn
              :disabled="!tokenRecap"
              ref="loginbtn"
              @click="login"
              class="mx-0 mx-md-5 mt-5 py-7"
              style="color: white"
              depressed
              large
              :loading="loading"
              color="#1D92E1"
              rounded
              >Log in</v-btn
            >
          </div>
          <div v-if="errorMessage" class="red--text text-center mt-3">* {{ errorMessage }}</div>
        </div>
      </ValidationObserver>
      <div class="hr-sect my-6">I don’t have an account</div>
      <div class="d-flex flex-column mt-5">
        <v-btn
          @click="goTo('regis')"
          class="mx-0 mx-md-5 py-7"
          style="background-color: transparent; color: #1d92e1"
          depressed
          large
          :loading="loading"
          rounded
          outlined
          color="#1D92E1"
          >Register</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import ThaiPhoneNumber from '@/components/ThaiPhoneNumber.vue'
import { VueRecaptcha } from 'vue-recaptcha'
import moment from 'moment'
import sprcApi from '@/api/sprc'
import { mapGetters } from 'vuex'

export default {
  components: {
    ThaiPhoneNumber,
    VueRecaptcha
  },
  data() {
    return {
      input: {
        phone_number: '',
        password: '',
        name: ''
      },
      loading: false,
      rememberme: false,
      recaptcha: undefined,
      timestamp: moment().format('x'),
      passwordType: 'password',
      tokenRecap: '',
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters(['setting'])
  },
  beforeCreate() {
    this.$store.state.bgcolor = '#efefef'
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },
  methods: {
    async getToken() {
      try {
        const resData = await sprcApi.getToken()
        if (resData?.data?.data?.access_token) {
          return resData.data.data.access_token
        }
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    showPasswordType() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
      } else if (this.passwordType == 'text') {
        this.passwordType = 'password'
      }
    },
    loginByUsername(response) {
      this.tokenRecap = response
    },
    goTo(path) {
      this.$store.dispatch('setPage', path)
    },
    async login() {
      let vm = this
      let token = this.tokenRecap
      if (token) {
        await vm.$refs.observer.validate().then((result) => {
          if (!result) {
            vm.resetRecaptcha()
            return false
          }

          vm.$store.state.recaptchaToken = token
          vm.onSubmit(token)
        })
      }
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset()
      this.timestamp = moment().format('x')
    },
    async onSubmit(token) {
      if (await this.$refs.observer.validate()) {
        const vm = this
        let data = {
          pageId: vm.$store.getters.setting.pageid,
          phone_number: vm.input.phone_number,
          // password: vm.input.password,
          g_recaptcha_response: token,
          name: vm.input.name
        }
        try {
          vm.loading = true
          const access_token = await this.getToken()
          const resData = await sprcApi.login(data, access_token)
          if (resData && resData.data && resData.data.userid) {
            this.$store.state.id = resData.data.userid
            localStorage.setItem('id', this.$store.state.id)
            await this.chatlog(this.$store.state.id, this.$store.getters.setting.pageid)
            this.$store.state.isJustLogin = true

            this.$store.commit('SET_LOGIN_STATUS', true)
            vm.errorMessage = null
          }
        } catch (error) {
          vm.loading = false
          vm.resetRecaptcha()
          console.error(error)
          if (error.response) {
            vm.errorMessage = error.response.data.message
          }
        } finally {
          vm.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
